import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { CountdownTimer } from './components/CountdownTimer';
import { Hero } from './components/Hero';
import { EmotionalMirror } from './components/EmotionalMirror';
import { Mechanism } from './components/Mechanism';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Authority } from './components/Authority';
import { FinalPrice } from './components/FinalPrice';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'Embarazo sin acidez - Clave de paz';
    }
  }, []);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const f: any = window;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    target.appendChild(script);
    window.fbq('init', '1652149349437497');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-terracotta/20" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1652149349437497&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <AnnouncementBar data-id="element-3" />
      <CountdownTimer data-id="element-4" />

      <main data-id="element-5">
        <Hero data-id="element-6" />
        <EmotionalMirror data-id="element-7" />
        <Mechanism data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Authority data-id="element-11" />
        <FinalPrice data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}